import { render, staticRenderFns } from "./MedicationAdd.vue?vue&type=template&id=2c300427"
import script from "./MedicationAdd.vue?vue&type=script&lang=js"
export * from "./MedicationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports